import TabContext from "@mui/lab/TabContext";
import PatientDetailsComponent from "./components/DetailsCard";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Tab,
  Typography,
} from "@mui/material";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { lazy, Suspense, useContext, useEffect, useState } from "react";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import VitalsList from "./components/VitalsList";
import PatientAllergy, {
  AllergyProvider,
} from "../../../EMR/components/Allergy";
import { HL7ContexTriggerContex } from "../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import { EmrDataProvider } from "../../../EMR";
const Complaints = lazy(() => import("../../../EMR/components/Complaints"));
const FamilyHistory = lazy(
  () => import("../../../EMR/components/History/FamilyHistory/FamilyHistory")
);
const SocialHistory = lazy(
  () => import("../../../EMR/components/History/socialHistory/Socialhistory")
);

const Nursingomponent = () => {
  const { triggerApi } = useContext(HL7ContexTriggerContex);
  const [value, setValue] = useState("1");
  const handleChange = (_: any, newValue: string) => {
    setValue(newValue);
    triggerApi();
  };

  const navigate = useNavigate();

  const naviagateBack = () => {
    triggerApi();
    navigate(-1);
  };

  // const eventTriggerApi = useCallback(()=>{
  //   triggerApi()
  // },[trigger,triggerApi])

  useEffect(() => {
    return () => {
      triggerApi();
    };
  }, []);
  return (
    <EmrDataProvider>
      <div className="flex justify-between">
        <Typography
          variant="h6"
          fontSize={".9rem"}
          fontWeight={"600"}
          className="text-blue-900 ps-3 pt-3"
        >
          Nursing Vitals
        </Typography>

        <Button
          startIcon={<ArrowBack />}
          className="!mt-5 !mr-5"
          color="error"
          onClick={naviagateBack}
        >
          Back
        </Button>
      </div>
      <div className="p-1">
        <PatientDetailsComponent />
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="vitals" value="1" />
              <Tab label="complaints" value="2" />
              <Tab label="Allergy" value="3" />
              <Tab label="Family History" value="4" />
              <Tab label="social History" value="5" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <Suspense fallback={<CircularProgress size={20} />}>
              <VitalsList />
            </Suspense>
          </TabPanel>
          <TabPanel value="2">
            <Suspense fallback={<CircularProgress size={20} />}>
              <Paper>
                <Complaints />
              </Paper>
            </Suspense>
          </TabPanel>
          <TabPanel value="3">
            <Suspense fallback={<CircularProgress size={20} />}>
              <AllergyProvider>
                <PatientAllergy />
              </AllergyProvider>
            </Suspense>
          </TabPanel>
          <TabPanel value="4">
            <Suspense fallback={<CircularProgress size={20} />}>
              <FamilyHistory />
            </Suspense>
          </TabPanel>
          <TabPanel value="5">
            <Suspense fallback={<CircularProgress size={20} />}>
              <SocialHistory />
            </Suspense>
          </TabPanel>
        </TabContext>
      </div>
    </EmrDataProvider>
  );
};

const NursingVitals = () => {
  return <Nursingomponent />;
};

export default NursingVitals;
